import { useEffect } from 'react'
import getPageByPath from 'shared/utils/getPageByPath'
import { useLocation } from 'react-router-dom'
import { apiUrls } from 'consts'
import getOne from 'utils/getOne'
import getAll from 'utils/getAll'

interface useInitProps {
  setReports: Function
  setPage: Function
  setToken: Function
  filterRole: object | null
}

const useInit = (props: useInitProps) => {
  const location = useLocation()

  useEffect(() => {
    const page = getPageByPath(location.pathname)
    props.setPage(page)

    // fetch customer token
    getOne(apiUrls.actionGetVslzToken).then((token) => {
      props.setToken(token)
    })

    if (page) {
      // fetch reports
      const reportsUrl = apiUrls.reports + '?id=' + page.id
      getAll(reportsUrl).then((reports) => {
        props.setReports(reports)
      })
    }
  }, [])
}

export default useInit
